define('views/parts/alert/alert-list',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    'utils',
    'views/parts/alert/alert-list-item',
    // templates
    'text!templates/parts/alert/alert-list.html',

], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VAlertListItem,
    // templates
    TAlertList
) {

    var VAlertList = Backbone.View.extend({
        template: TAlertList,
        // events: {
        // 'event:name .event-selector': 'callback'
        // },

        regions: {
            list: ".alert-list",
        },

        initialize: function(options) {
            this.rendered = 0;

            this.options = _.extend({
                autoDismiss: 20,
                dismissable: true,
                limit: 4,
                summary: true,
            }, options);

            if (!this.collection) {
                this.collection = new Backbone.Collection();
            }


            this.listenTo(this.collection, {
                "add": this.renderItem,
                "reset": this.resetList,
                "alert:close": this.onRemoveAlert,
            });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template));

            // caching scoped jquery element from 'regions'.
            this.generateZones();

            this.resetList();

            return this;
        },

        /**
         * Ensures a cleanup of the element and childViews, then defer the new
         * list rendering.
         */
        resetList: function() {
            this.zone.$list.empty();
            this.rendered = 0;

            this.removeChildViews({ defer: true });

            this.renderAll();
        },

        /**
         * Creates child views in specified chunk and appends them to the DOM.
         * @param  {Array} models, optionnal, rest of the initial collection to render.
         */
        renderAll: function(models) {
            // Quick way to determine if the view is rendered yet.
            if (!this.zone) {
                return;
            }

            var collection = models || this.collection.toArray(),
                delay = 125, // could/should be inside the defaults object.
                count = 1;

            if (collection.length > 0) {
                this.zone.$list.append(this.renderItem(_.first(collection), this.collection));

                // defer the rendering of the rest of the models.
                if (collection.length > 1 && !this.hasReachedLimit()) {
                    _.delay(this.renderAll.bind(this), delay, _.rest(collection));
                }
            }
        },

        renderItem: function(model, collection, options) {
            if (!this.zone) return;

            var view = new VAlertListItem({
                model: model,
            });

            // keep a reference to the child view for a later cleanup, avoiding
            // memory leaks with undelegated events, and other stuff.
            this.childViews.push(view);
            this.zone.$list.append(view.render().el);
            this.rendered++;
        },

        addAlert: function(type, message, options) {
            options = options || {};
            if (_.isUndefined(options.dismissable)) {
                options.dismissable = this.options.dismissable;
            }
            if (!_.isArray(message)) message = [message];

            message = _.map(message, function(msg) {
                return {
                    type: type,
                    message: msg,
                    dismissable: options.dismissable,
                };
            });

            this.collection.push(message, options);
        },


        addError: function(message, options) {
            this.addAlert("danger", message, options);
        },

        addInfo: function(message, options) {
            this.addAlert("info", message, options);
        },

        getLimit: function() {
            return this.options.limit;
        },

        hasLimit: function() {
            return this.options.limit > 0 || this.options.limit !== false;
        },

        hasReachedLimit: function() {
            return this.hasLimit() && this.rendered >= this.options.limit;
        },

        reset: function(models, options) {
            this.collection.reset(models, options);
            return this;
        },

        ////////////
        // events //
        ////////////

        onRemoveAlert: function(model) {
            this.collection.remove(model);
        },

        /**
         * When the view el is replaced by another view, but it'll
         * serve again and will be re-rendered.
         */
        onDisable: function() {
            this.removeChildViews({ defer: true });
        },

        /** hook on the default remove function */
        // onRemove: function() {
        //
        // }

    });

    return VAlertList;

});

